import {createReducer} from '@reduxjs/toolkit';
import {
  SetPendingBusinesses,
  SetRejectedBusinesses,
  SetBusinessPagination,
  SetRejectedPagination,
  SetAllBusinesses,
  SetAllBusinessesPagination,
} from './ActionTypes/Business';

interface BusinessState {
  pendingBusinesses: any[];
  rejectedBusinesses: any[];
  allBusinesses: any[];
  pendingPagination: {count: number; pages: number};
  rejectedPagination: {count: number; pages: number};
  allBusinessesPagination: {count: number; pages: number};
}

const initialState: BusinessState = {
  pendingBusinesses: [],
  rejectedBusinesses: [],
  allBusinesses: [],
  pendingPagination: {count: 0, pages: 0},
  rejectedPagination: {count: 0, pages: 0},
  allBusinessesPagination: {count: 0, pages: 0},
};

const businessReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SetPendingBusinesses, (state, action) => {
      state.pendingBusinesses = action.payload;
    })
    .addCase(SetRejectedBusinesses, (state, action) => {
      state.rejectedBusinesses = action.payload;
    })
    .addCase(SetBusinessPagination, (state, action) => {
      state.pendingPagination = action.payload;
    })
    .addCase(SetRejectedPagination, (state, action) => {
      state.rejectedPagination = action.payload;
    })
    .addCase(SetAllBusinesses, (state, action) => {
      state.allBusinesses = action.payload;
    })
    .addCase(SetAllBusinessesPagination, (state, action) => {
      state.allBusinessesPagination = action.payload;
    });
});

export default businessReducer;
